const pub = process.env.PUBLIC_URL;

export default function Stripes() {
  return (
    <div style={{ width: '100%', lineHeight: 0 }}>
      <img src={`${pub}/STRIPES.svg`} alt="" style={{ width: '100%', display: 'block' }} />
    </div>
  );
}
